<style lang="less" scoped>
.img-in-table{
  max-height: 120px;
}
</style>
<template>
  <el-dialog title="人脸库1vN检测" :close-on-click-modal=false :destroy-on-close="true"
  :visible.sync="visible" width="700px" :before-close="closeDialog">
    
      <div v-if="!file" class="tip"><i class="el-icon-sunrise-1"></i> 请选择一张图片</div>
      <span style="margin-right: 20px;">返回前
        <el-input-number size="mini" controls-position="right" v-model="topN" 
        :step="1" step-strictly :min="1" :max="30" style="width: 90px;"></el-input-number>
        条匹配结果</span>
      <image-select @select="file = $event[0]"></image-select>
      
      <image-preview ref="imagePreview" :file="file" @update="detect"></image-preview>
      <el-table style="margin-top: 30px;" :data="resultList" v-loading="loading">
        <el-table-column label="人脸" align="center">
          <template v-slot="scope">
            <img class="img-in-table" :src="src(scope.row)" :title="scope.row.key">
          </template>
        </el-table-column>
        <el-table-column label="匹配度" prop="match" align="center">
          <template v-slot="scope">
            {{Math.round(scope.row.match * 100 * 100) / 100 + '%'}}
          </template>
        </el-table-column>
      </el-table>
  </el-dialog>
</template>

<script>
import ImageSelect from "@/components/image-select.vue";
import ImagePreview from "@/components/image-preview.vue";

export default {
  components: {
    ImageSelect,
    ImagePreview
  },
  props: {
    bucketId: Number,
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      file: null,
      topN: 5,
      resultList: [],
      loading: false
    }
  },
  methods: {
    src(e) {
      return this.$api.model.image({ bucket: this.bucketId, key: e.key });
    },
    async detect({ file, canvas, percent }) {
      if(file){
        this.loading = true;
        let res = await this.$request(this.$api.bucket.compare({ bucket: this.bucketId, image: file,  size: this.topN }))
        if (res.length === 0) {
          this.loading = false;
          this.$message.warning("无匹配结果");
          return;
        }else{
          this.loading = false;
          this.resultList = res;
        }
      }
    },
    closeDialog() {
      this.$emit('update:visible', false);
      this.file = null;
      this.resultList = []
    },
  }
}
</script>